module.exports = __webpack_public_path__ + "img/93.2.TN.d699e983.png";